export default __webpack_public_path__ + "static/sideView-a235fc779e1447679b70369b33c30294.png";